import { render, staticRenderFns } from "./ModalSolicitacaoDeOrcamento.vue?vue&type=template&id=a14b80c4&scoped=true"
import script from "./ModalSolicitacaoDeOrcamento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSolicitacaoDeOrcamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalSolicitacaoDeOrcamento.vue?vue&type=style&index=0&id=a14b80c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14b80c4",
  null
  
)

export default component.exports